// @flow
import AddSvgIconSprite from './components/AddSvgIconSprite';
import GtmHandler from './components/GtmHandler';
import PromoLP from './components/promoLP/PromoLP';
import ImageParallax from './components/promoLP/ImageParallax';
import ContentVideo from './components/ContentVideo';
import ProductListSlider from './components/ProductListSlider';
import PromoLPGallery from './components/promoLP/PromoLPGallery';
import PromoLpDesignersSlider from './components/promoLP/PromoLpDesignersSlider';

// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
import AlertBox from 'fg-frontend/src/components/AlertBox';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AlertBox':
      return AlertBox;
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'GtmHandler':
      return GtmHandler;
    case 'ContentVideo':
      return ContentVideo;
    case 'PromoLP':
      return PromoLP;
    case 'PromoLPGallery':
      return PromoLPGallery;
    case 'SelectDesign':
      return import('./components/SelectDesign');
    case 'Form':
      return import('fg-frontend/src/components/Form');
    case 'FileInput':
      return import('fg-frontend/src/components/FileInput');
    case 'FGUpload':
      return import('./components/FGUpload');
    case 'ImageParallax':
      return ImageParallax;
    case 'PromoLpDesignersSlider':
      return PromoLpDesignersSlider;
    case 'ProductListSlider':
      return ProductListSlider;
    case 'GoogleRecaptcha': // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'PreventDoubleClickHandler': // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureLandingPageComponents.js